import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import glassesService from "../../../services/glasses.service";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import { useMemo } from "react";
import { DialogContent, Grid } from "@material-ui/core";

const initialValues = {
  count: 0,
  lensSize: 0,
  bridgeSize: 0,
  templeLength: 0,
  hingeToHinge: 0,
  lensHeight: 0,
};
const schema = Yup.object().shape({
  lensSize: yupSchema.lensSize,
  bridgeSize: yupSchema.bridgeSize,
  templeLength: yupSchema.templeLength,
  hingeToHinge: yupSchema.hingeToHinge,
  lensHeight: yupSchema.lensHeight,
});

const FormWrapper = ({ children }) => (
  <DialogContent>
    <Grid container spacing={2}>
      {children}
    </Grid>
  </DialogContent>
);

export default function FormModalContent({ close, data, extra, parent }) {
  const errorHandler = useErrorHandler();

  const form = useMemo(
    () => [
      {
        _type: "textField",
        name: "count",
        type: "number",
        label: "موجودی",
        disabled: Boolean(data?.id),
        autoFocus: true,
        inputProps: {
          min: 0,
        },
      },
      {
        _type: "textField",
        name: "lensSize",
        type: "number",
        label: "طول لنز",
        inputProps: {
          min: 0,
        },
      },
      {
        _type: "textField",
        name: "lensHeight",
        type: "number",
        label: "ارتفاع لنز",
        inputProps: {
          min: 0,
        },
      },
      {
        _type: "textField",
        name: "bridgeSize",
        type: "number",
        label: "طول پل",
        inputProps: {
          min: 0,
        },
      },
      {
        _type: "textField",
        name: "templeLength",
        type: "number",
        label: "طول دسته",
        inputProps: {
          min: 0,
        },
      },
      {
        _type: "textField",
        name: "hingeToHinge",
        type: "number",
        label: "لولا به لولا",
        inputProps: {
          min: 0,
        },
      },
    ],
    [data?.id]
  );

  const handleSubmit = async (model, { setSubmitting }) => {
    let op;
    if (data?.id) {
      delete model.count;
      op = await glassesService.editGlassesSize(data.id, model);
    } else {
      op = await glassesService.createGlassesSize({
        ...model,
        glassesColorId: parent.data.id,
      });
    }
    const { error } = op;
    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };
  return (
    <DialogFormBuilder
      {...{
        close,
        name: "سایز عینک",
        data,
        schema,
        initialValues,
        handleSubmit,
        form,
        formWrapper: FormWrapper,
      }}
    />
  );
  // return (
  //   <Loading isLoading={waiting} overlay>
  //     <DialogTitle onClose={() => close()}>
  //       {id ? "ویرایش عینک" : "ایجاد عینک"}
  //     </DialogTitle>
  //     <Divider />
  //     <Formik
  //       initialValues={id ? initialValues : emptyValues}
  //       onSubmit={handleSubmit}
  //       validationSchema={formSchema}
  //     >
  //       {({ isSubmitting, values }) => (
  //         <Form autoComplete="off">
  //           <DialogContent>
  //             <FTextField name="name" label="نام" autoFocus />
  //             <FTextField name="summery" label="خلاصه توضیحات"  />
  //             <FTextField name="description" label="توضیحات" />
  //             <FTextField name="weight" label="وزن" type="number" />
  //           </DialogContent>
  //           <DialogActions>
  //             <Button onClick={close} color="primary" disabled={isSubmitting}>
  //               لغو
  //             </Button>
  //             <Button
  //               type="submit"
  //               disabled={isSubmitting}
  //               variant="contained"
  //               color="primary"
  //             >
  //               {id ? "ذخیره" : "ایجاد"}
  //             </Button>
  //           </DialogActions>
  //         </Form>
  //       )}
  //     </Formik>
  //   </Loading>
  // );
}
